import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { DiJavascript1, DiCss3Full, DiHtml5, DiReact } from "react-icons/di";
import { FaFileExcel, FaFilePdf, FaImage, FaJsSquare } from "react-icons/fa";

const FILE_ICONS = {
  js: <FaJsSquare color="rgb(255, 255, 0)"/>,
  css: <DiCss3Full />,
  html: <DiHtml5 />,
  jsx: <DiReact />,
  pdf: <FaFilePdf color="rgb(255 52 0)"/>,
  xlsx: <FaFileExcel color="#1971c2" style={{backgroundColor:"white"}} />,
  zohosheet: <FaFileExcel color="#1971c2" style={{backgroundColor:"white"}} />,
  spreadsheet: <FaFileExcel color="#1971c2" style={{backgroundColor:"white"}} />,
  png: <FaImage color="rgb(36 164 255)" style={{backgroundColor:"white"}} />,
  image: <FaImage color="rgb(36 164 255)" style={{backgroundColor:"white"}} />,
  jpg: <FaImage color="rgb(36 164 255)" style={{backgroundColor:"white"}} />,
  jpeg: <FaImage color="rgb(36 164 255)" style={{backgroundColor:"white"}} />,
  svg: <FaImage color="rgb(36 164 255)" style={{backgroundColor:"white"}} />,
};

export default FILE_ICONS;
